import { Field } from 'components/Wizards/Field/Field'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = {
  culture?: string
  onUpdate: (culture: string) => void
  labelColor?: string
}

const RepresentationCulture = ({ culture, onUpdate, labelColor }: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Field label="Ethnicity" labelType="label" data-testid="representation-culture" labelColor={labelColor}>
      <Select
        aria-label="Ethnicity"
        variant="secondary"
        selectedKey={culture || 'multicultural_diverse'}
        onSelectionChange={(key) => onUpdate(key as string)}
        placeholder="Select culture"
        size="lg"
        useFullWidth={isMobile}
      >
        <Item key="hispanic_latino">Hispanic / Latino</Item>
        <Item key="asian">Asian</Item>
        <Item key="black_african">Black / African Descent</Item>
        <Item key="white_caucasian">White / Caucasian</Item>
        <Item key="middle_eastern">Middle Eastern</Item>
        <Item key="multicultural_diverse">Multicultural / Diverse Group</Item>
      </Select>
    </Field>
  )
}

export { RepresentationCulture }
